import { makeStyles } from '@material-ui/core';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  root: {
    gridColumn: '1 / -1',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    width: '100%',
    padding: '1.5rem',
    boxSizing: 'border-box',
  },
  panel: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '40rem',
    backgroundColor: neutral.white,
    border: `1px solid ${neutral.D10}`,
    borderRadius: '0.625rem',
    boxShadow: `0 0.3125rem 0.625rem ${neutral[100]}0A`,
    overflow: 'hidden',
  },
  panelHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.75rem',
    borderBottom: `1px solid ${neutral.D11}`,
  },
  panelTitle: {
    margin: 0,
    fontWeight: 600,
    fontSize: '0.75rem',
    lineHeight: '1.125rem',
    letterSpacing: '0.075rem',
    textTransform: 'uppercase',
    color: neutral[60],
  },
  countBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '1.5rem',
    height: '1.5rem',
    padding: '0 0.5rem',
    border: `1px solid ${neutral.D10}`,
    borderRadius: '0.25rem',
    boxSizing: 'border-box',
    fontWeight: 600,
    fontSize: '0.75rem',
    lineHeight: '1.125rem',
    color: neutral.D18,
  },
  panelBody: {
    padding: '0.75rem',
  },
  list: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
  },
  listItem: {
    margin: 0,
    padding: 0,
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '3rem 1.5rem',
    gap: '0.5rem',
    textAlign: 'center',
  },
  emptyTitle: {
    margin: 0,
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: '1.5rem',
    color: neutral[90],
  },
  emptyDescription: {
    margin: 0,
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: '1.375rem',
    color: neutral[60],
  },
});
